import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { price } from '../data/product';
export function BonusSection() {
  return <section className="bg-stone-100 px-5 py-20" data-id="element-1" data-mp="1oi811bi6d428">
      <div className="mx-auto max-w-5xl" data-id="element-2" data-mp="22eli4jisr3g6">
        <div className="text-center" data-id="element-3" data-mp="22dajey47klvx">
          <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[.22em] text-sage-700" data-id="element-4" data-mp="1ydrwjwstu0qg">
            <GiftIcon className="h-4 w-4" data-id="element-5" data-mp="1ap8mpcu4pfw9" />
            Included today at no extra cost
          </p>
          <h2 className="mt-4 font-display text-[2.1rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-ink-900 sm:text-5xl" data-id="element-6" data-mp="15qxfzaz4rli9">
            Five strategic bonus assets
          </h2>
          <p className="mt-4 text-sm text-ink-600" data-id="element-7" data-mp="1ep94n7gfs982">
            Total bonus value: {price.bonusValue} — included free with your
            purchase.
          </p>
        </div>
        <div className="mt-11 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-8" data-mp="mzo3csu2cgmg">
          {bonuses.map(({
          icon: Icon,
          title,
          value,
          description,
          imageUrl
        }, index) => <article key={title} className="flex flex-col overflow-hidden border border-line bg-white" data-id="element-9" data-mp="2eqwhjbfehodg" data-mpi={index}>
                <img src={imageUrl} alt={`Preview of the bonus: ${title}`} width={1024} height={1024} loading="lazy" className="aspect-[4/3] w-full object-cover" data-id="element-10" data-mp="2jio99paam056" />
                <div className="flex flex-1 flex-col p-6" data-id="element-11" data-mp="1vstxzc5mgjn1">
                  <div className="flex items-center justify-between gap-4" data-id="element-12" data-mp="20qvgnvz4ygxz">
                    <span className="grid h-10 w-10 place-items-center border border-line bg-stone-50" data-id="element-13" data-mp="20trb3abrynho">
                      <Icon className="h-4 w-4 text-sage-600" data-id="element-14" data-mp="3c6k2gk0nl9x7" />
                    </span>
                    <p className="text-[11px] font-semibold uppercase tracking-[.18em] text-ink-600" data-id="element-15" data-mp="3c8wgim3aj04z">
                      Bonus {String(index + 1).padStart(2, '0')}
                    </p>
                  </div>
                  <h3 className="mt-6 font-display text-xl font-semibold leading-tight text-ink-900" data-id="element-16" data-mp="1c4kk0oeevmm2">
                    {title}
                  </h3>
                  <p className="mt-1 text-[11px] font-semibold uppercase tracking-[.14em] text-clay-500" data-id="element-17" data-mp="1q3jxr10dyh3g">
                    {value} — free today
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-ink-600" data-id="element-18" data-mp="yc4engy1fchz">
                    {description}
                  </p>
                </div>
              </article>)}
        </div>
      </div>
    </section>;
}